import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import SimplePagination from '@client/components/paginations/simplePagination/SimplePagination';
import {
  getSearchParams,
  getSearchQueryValue,
} from '@client/shared/utils/urlUtils/urlUtils';

const UrlPagination = ({ history, location, pageCount, className }) => {
  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    // Avoid auto-scrolling on initial page load. Only scroll when the query changes
    // (e.g. pagination/search updates), so the listing stays in view after navigation.
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }

    const element = document.getElementById('listingSection');
    if (!element) return;

    element.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth',
    });
  }, [location.search]);

  const handlePaginationBtnClick = (index) => {
    const searchTest = getSearchParams(location, {
      addParamsObj: { page: index },
    });

    history.push({
      search: searchTest,
    });
  };

  const currentPage = getSearchQueryValue(location.search, 'page');

  return (
    <div className={`${className ? ` ${className}` : ''}`}>
      <SimplePagination
        pageCount={pageCount}
        currentPage={parseInt(currentPage || 1)}
        onPaginationBtnClick={handlePaginationBtnClick}
      />
    </div>
  );
};

UrlPagination.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  pageCount: PropTypes.number,
  location: PropTypes.object,
  onPaginationBtnClick: PropTypes.func,
};

export default withRouter(UrlPagination);
